import client from "./client";

const getGameTopList = (data = {}) => client.post("/getGameTopList", data);

const getGameList = (page: number, pageSize: number, type: number, params: string) =>
    client.post("/getGameList", {
        pageId: page,
        pageCount: pageSize,
        type,
        params,
    });

const getOriginalGameList = () =>
    client.post("/getGameList", {
        pageId: 0,
        pageCount: 0,
        type: 4,
        params: "1",
    });

const getCollectStatus = (gameId: number, langId: number) => client.post("/getGameIsCollectById", {gameId, langId});

const addCollect = (gameId: number, langId: number) => client.post("/addGameCollection", {gameId, langId});

const removeCollect = (gameId: number, langId: number) => client.post("/removeGameCollection", {gameId, langId});

const getGameCollectList = (page: number, pageSize: number) =>
    client.post("/getCollectList", {
        pageId: page,
        pageCount: pageSize,
    });

const getGameHistoryList = (page: number, pageSize: number) =>
    client.post("/getPlayGameHistoryList", {
        pageId: page,
        pageCount: pageSize,
    });

const getRelatedGameList = (providerId: number) =>
    client.post("/getGameList", {
        pageId: 1,
        pageCount: 20,
        type: 2,
        params: providerId,
    });

const getGameBrandList = (page = 0, pageSize = 0) =>
    client.post("/getGameBrandList", {
        pageId: page,
        pageCount: pageSize,
    });

const apiCasino = {
    getGameList,
    getGameTopList,
    getCollectStatus,
    addCollect,
    removeCollect,
    getGameCollectList,
    getGameHistoryList,
    getRelatedGameList,
    getOriginalGameList,
    getGameBrandList,
};

export default apiCasino;
